import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AdviceTodayResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/advice/advice-today.response';
import { AdviceTrigger } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@enums/advice-trigger.enum';
import { WillyChatService } from '../../../@commons/@services/front/willy-chat.service';

interface ChipStyle {
  background: string;
  ink: string;
  emoji: string;
}

const CHIP_STYLES: Record<string, ChipStyle> = {
  [AdviceTrigger.FROST]: { background: '#E0F2FE', ink: '#075985', emoji: '❄️' },
  [AdviceTrigger.HEAVY_RAIN]: { background: '#E1EDFE', ink: '#1A4166', emoji: '🌧️' },
  [AdviceTrigger.HEATWAVE]: { background: '#FEF3C7', ink: '#92400E', emoji: '☀️' },
  [AdviceTrigger.DRY_SPELL]: { background: '#FEF9C3', ink: '#854D0E', emoji: '💧' },
  [AdviceTrigger.STRONG_WIND]: { background: '#F1F5F9', ink: '#475569', emoji: '💨' },
  [AdviceTrigger.LUNAR_ROOT]: { background: '#E4E1FE', ink: '#261E77', emoji: '🌙' },
  [AdviceTrigger.LUNAR_LEAF]: { background: '#E4E1FE', ink: '#261E77', emoji: '🌙' },
  [AdviceTrigger.LUNAR_FLOWER]: { background: '#E4E1FE', ink: '#261E77', emoji: '🌙' },
  [AdviceTrigger.LUNAR_FRUIT]: { background: '#E4E1FE', ink: '#261E77', emoji: '🌙' },
};

/**
 * Standalone home section: today's advice cards (weather/lunar triggers ×
 * the user's growing plants). Data is fetched once by the home component.
 */
@Component({
  selector: 'vw-garden-advices-widget',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './garden-advices-widget.component.html',
})
export class GardenAdvicesWidgetComponent {
  @Input() advice: AdviceTodayResponse | null = null;

  constructor(private willyChatService: WillyChatService) {}

  get cards() {
    return this.advice?.advices ?? [];
  }

  chipStyle(trigger: string): ChipStyle {
    return CHIP_STYLES[trigger] ?? { background: '#F5F5F5', ink: '#3c4a45', emoji: '🌱' };
  }

  askWilly() {
    this.willyChatService.openChat();
  }
}
